import { Disciplines } from '../../domain';
import ResultsSJTableHead from './components/ResultsSJTableHead/ResultsSJTableHead.component';
import ResultsDRTableHead from './components/ResultsDRTableHead/ResultsDRTableHead.component';
import ResultsETTableHead from './components/ResultsETTableHead/ResultsETTableHead.component';
import ResultsCBTableHead from './components/ResultsCBTableHead/ResultsCBTableHead.component';
import ResultsHTTableHead from './components/ResultsHTTableHead/ResultsHTTableHead.component';
import ResultsSETableHead from './components/ResultsSETableHead/ResultsSETableHead.component';

export default function getResultsTableHead(discipline?: Disciplines) {
  switch (discipline) {
    case Disciplines.Showjumping:
      return ResultsSJTableHead;
    case Disciplines.Dressage:
      return ResultsDRTableHead;
    case Disciplines.EventerTrial:
      return ResultsETTableHead;
    case Disciplines.CombinedTraining:
      return ResultsCBTableHead;
    case Disciplines.HunterTrials:
      return ResultsHTTableHead;
    case Disciplines.Shows:
    case Disciplines.MixedEvents:
      return ResultsSETableHead;
    default:
      return ResultsDRTableHead;
  }
}
